import { Component, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'era-device-mdm-sync-force-ui',
  templateUrl: './device-mdm-sync-force.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormsModule],
})
export class DeviceMdmSyncForceComponent implements OnInit {
  public readonly allowForce = input.required<boolean>();
  public readonly forceSync = output<boolean>();

  public readonly forceSyncForm: UntypedFormControl = new UntypedFormControl(false);

  ngOnInit(): void {
    if (this.allowForce()) {
      this.forceSyncForm.enable();
    } else {
      this.forceSyncForm.disable();
    }

    this.forceSyncForm.valueChanges.subscribe((value: boolean) => {
      this.forceSync.emit(value);
    });
  }
}
